/*
 * QueryEncoderHelper
 * Fix plus sign (+) not encoding, so sent as blank space
 * See: https://github.com/angular/angular/issues/11058#issuecomment-247367318
 */
import { QueryEncoder } from "@angular/http";

export class QueryEncoderHelper extends QueryEncoder {
    encodeKey(k: string): string {
        k = super.encodeKey(k);
        return k.replace(/\+/gi, '%2B')
            .replace(/ /gi, '%20');
    }
    encodeValue(v: string): string {
        // alert(v);
        v = super.encodeValue(v);
        // alert(v);
        // return v.replace(/\+/gi, '%2B')
        //     .replace(/ /gi, '%20');
        return v;
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/common/query-encoder-helper.ts